var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCoins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58.007 58.007",
    style: {
      enableBackground: "new 0 0 58.007 58.007"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_22_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_143_",
    style: {
      fill: "#FCC62D"
    },
    d: "M52.003,29.211v1.238c0,6.932-11.641,12.551-26,12.551 c-7.926,0-15.019-1.714-19.788-4.414C7.823,44.831,18.751,50,32.003,50c14.359,0,26-6.068,26-13 C58.003,33.952,55.747,31.266,52.003,29.211"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_142_",
    style: {
      fill: "#E4AF18"
    },
    d: "M32.003,50c-14.359,0-26-6.068-26-13v8.448c0,6.932,11.641,12.552,26,12.552 s26-5.62,26-12.552V37C58.003,43.932,46.362,50,32.003,50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_141_",
    style: {
      fill: "#CE9912"
    },
    d: "M9.003,51.349c0.59,0.539,1.259,1.055,2,1.545v-8.291 c-0.741-0.51-1.41-1.045-2-1.603V51.349z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_140_",
    style: {
      fill: "#CE9912"
    },
    d: "M53.003,44.603v8.291c0.741-0.489,1.41-1.006,2-1.545V43 C54.414,43.558,53.745,44.093,53.003,44.603"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_139_",
    style: {
      fill: "#CE9912"
    },
    d: "M13.003,54.06c0.632,0.327,1.3,0.636,2,0.929v-8.193 c-0.7-0.308-1.368-0.633-2-0.975V54.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_138_",
    style: {
      fill: "#CE9912"
    },
    d: "M49.003,54.988c0.7-0.292,1.368-0.602,2-0.929V45.82 c-0.632,0.342-1.3,0.668-2,0.975V54.988z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_137_",
    style: {
      fill: "#CE9912"
    },
    d: "M17.003,55.745c0.646,0.221,1.313,0.427,2,0.619V48.25 c-0.687-0.204-1.354-0.423-2-0.656V55.745z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_136_",
    style: {
      fill: "#CE9912"
    },
    d: "M45.003,56.364c0.687-0.192,1.354-0.398,2-0.619v-8.151 c-0.646,0.233-1.313,0.452-2,0.656V56.364z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_135_",
    style: {
      fill: "#CE9912"
    },
    d: "M22.003,57.084c0.653,0.132,1.321,0.25,2,0.355v-8.044 c-0.679-0.113-1.347-0.239-2-0.379V57.084z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_134_",
    style: {
      fill: "#CE9912"
    },
    d: "M40.003,57.439c0.679-0.106,1.347-0.224,2-0.355v-8.069 c-0.653,0.14-1.321,0.266-2,0.38V57.439z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_133_",
    style: {
      fill: "#CE9912"
    },
    d: "M28.003,57.899c0.658,0.049,1.326,0.083,2,0.107v-8.003 c-0.674-0.026-1.342-0.062-2-0.115V57.899z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_132_",
    style: {
      fill: "#CE9912"
    },
    d: "M34.003,58.007c0.674-0.025,1.342-0.058,2-0.107v-8.012 c-0.658,0.053-1.326,0.089-2,0.116V58.007z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_131_",
    style: {
      fill: "#E4AF18"
    },
    d: "M26.003,34.993c-14.359,0-26-6.068-26-13v8.448c0,6.932,11.641,12.552,26,12.552 s26-5.62,26-12.552v-8.448C52.003,28.925,40.362,34.993,26.003,34.993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_130_",
    style: {
      fill: "#CE9912"
    },
    d: "M3.003,36.342c0.59,0.539,1.259,1.055,2,1.545v-8.291 c-0.741-0.51-1.41-1.045-2-1.602V36.342z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_129_",
    style: {
      fill: "#CE9912"
    },
    d: "M47.003,29.596v8.291c0.741-0.489,1.41-1.006,2-1.545v-8.349 C48.414,28.551,47.745,29.086,47.003,29.596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_128_",
    style: {
      fill: "#CE9912"
    },
    d: "M7.003,39.053c0.632,0.327,1.3,0.636,2,0.929v-8.193 c-0.7-0.308-1.368-0.633-2-0.975V39.053z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_127_",
    style: {
      fill: "#CE9912"
    },
    d: "M43.003,39.981c0.7-0.292,1.368-0.601,2-0.929v-8.239 c-0.632,0.342-1.3,0.668-2,0.975V39.981z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_126_",
    style: {
      fill: "#CE9912"
    },
    d: "M11.003,40.738c0.646,0.221,1.313,0.427,2,0.619v-8.114 c-0.687-0.204-1.354-0.423-2-0.656V40.738z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_125_",
    style: {
      fill: "#CE9912"
    },
    d: "M39.003,41.357c0.687-0.192,1.354-0.398,2-0.619v-8.151 c-0.646,0.233-1.313,0.452-2,0.656V41.357z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_124_",
    style: {
      fill: "#CE9912"
    },
    d: "M16.003,42.077c0.653,0.132,1.321,0.25,2,0.355v-8.044 c-0.679-0.113-1.347-0.239-2-0.379V42.077z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_123_",
    style: {
      fill: "#CE9912"
    },
    d: "M34.003,42.433c0.679-0.106,1.347-0.224,2-0.355v-8.069 c-0.653,0.14-1.321,0.266-2,0.38V42.433z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_122_",
    style: {
      fill: "#CE9912"
    },
    d: "M22.003,42.893c0.658,0.049,1.326,0.083,2,0.107v-8.003 c-0.674-0.026-1.342-0.062-2-0.115V42.893z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_121_",
    style: {
      fill: "#CE9912"
    },
    d: "M28.003,43c0.674-0.025,1.342-0.058,2-0.107v-8.012 c-0.658,0.053-1.326,0.089-2,0.116V43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_120_",
    style: {
      fill: "#FFD949"
    },
    d: "M51.32,33.302C48.643,38.858,38.329,43,26.003,43c-4.604,0-8.926-0.58-12.677-1.593 c3.628,2.463,10.085,4.559,18.677,4.559c13.682,0,22-5.311,22-8.966C54.003,35.78,53.064,34.486,51.32,33.302"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_119_",
    style: {
      fill: "#FFD949"
    },
    d: "M31.003,33c-14.359,0-26-5.62-26-12.552v-5.652c-3.141,1.969-5,4.438-5,7.204 c0,6.932,11.641,13,26,13c6.914,0,13.192-1.409,17.849-3.642C40.061,32.401,35.678,33,31.003,33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_118_",
    style: {
      fill: "#E4AF18"
    },
    d: "M31.003,24.993c-14.359,0-26-6.068-26-13v8.448c0,6.932,11.641,12.552,26,12.552 c14.359,0,26-5.62,26-12.552v-8.448C57.003,18.925,45.362,24.993,31.003,24.993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_117_",
    style: {
      fill: "#CE9912"
    },
    d: "M8.003,26.342c0.59,0.539,1.259,1.055,2,1.545v-8.291 c-0.741-0.51-1.41-1.045-2-1.602V26.342z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_116_",
    style: {
      fill: "#CE9912"
    },
    d: "M52.003,19.596v8.291c0.741-0.489,1.41-1.006,2-1.545v-8.349 C53.414,18.551,52.745,19.086,52.003,19.596"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_115_",
    style: {
      fill: "#CE9912"
    },
    d: "M12.003,29.053c0.632,0.327,1.3,0.636,2,0.929v-8.193 c-0.7-0.308-1.368-0.633-2-0.975V29.053z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_114_",
    style: {
      fill: "#CE9912"
    },
    d: "M48.003,29.981c0.7-0.292,1.368-0.601,2-0.929v-8.239 c-0.632,0.342-1.3,0.668-2,0.975V29.981z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_113_",
    style: {
      fill: "#CE9912"
    },
    d: "M16.003,30.738c0.646,0.221,1.313,0.427,2,0.619v-8.114 c-0.687-0.204-1.354-0.423-2-0.656V30.738z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_112_",
    style: {
      fill: "#CE9912"
    },
    d: "M44.003,31.357c0.687-0.192,1.354-0.398,2-0.619v-8.151 c-0.646,0.233-1.313,0.452-2,0.656V31.357z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_111_",
    style: {
      fill: "#CE9912"
    },
    d: "M21.003,32.077c0.653,0.132,1.321,0.25,2,0.355v-8.044 c-0.679-0.113-1.347-0.239-2-0.379V32.077z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_110_",
    style: {
      fill: "#CE9912"
    },
    d: "M39.003,32.433c0.679-0.106,1.347-0.224,2-0.355v-8.069 c-0.653,0.14-1.321,0.266-2,0.38V32.433z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_109_",
    style: {
      fill: "#CE9912"
    },
    d: "M27.003,32.893c0.658,0.049,1.326,0.083,2,0.107v-8.003 c-0.674-0.026-1.342-0.062-2-0.115V32.893z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_108_",
    style: {
      fill: "#CE9912"
    },
    d: "M33.003,33c0.674-0.025,1.342-0.058,2-0.107v-8.012 c-0.658,0.053-1.326,0.089-2,0.116V33z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_107_",
    style: {
      fill: "#FCC62D"
    },
    d: "M57.003,12c0,6.932-11.641,13-26,13c-14.359,0-26-6.068-26-13 c0-6.932,11.641-12,26-12C45.362,0,57.003,5.068,57.003,12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_106_",
    style: {
      fill: "#FFD949"
    },
    d: "M31.003,20.966c-13.682,0-22-5.31-22-8.966c0-3.655,8.318-9,22-9 c13.682,0,22,5.345,22,9C53.003,15.656,44.685,20.966,31.003,20.966"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_105_",
    style: {
      fill: "#F0C41B"
    },
    d: "M37.784,13.359c0.82-0.174,1.301-0.68,1.124-1.257l-0.19-0.616 c-0.139-0.453-0.68-0.831-1.343-1.019c-0.902-1.927-3.202-2.625-6.618-2.625c-0.162,0-0.32,0.004-0.476,0.01 c-1.166,0.048-2.329-0.064-3.236-0.396c-0.37-0.135-0.671-0.276-0.87-0.423c-0.09-0.066-0.308-0.024-0.308,0.06 c0,0.146,0.011,0.319,0.043,0.511c0.124,0.747-0.024,0.635-0.762,1.38c-0.428,0.434-0.769,0.934-1.016,1.486 c-0.659,0.189-1.197,0.566-1.336,1.017l-0.19,0.616c-0.177,0.577,0.304,1.083,1.124,1.257c0.234,1.476,1.237,2.772,3.424,3.486 l-0.12,1.037c-0.032,0.277-0.271,0.533-0.619,0.659l-4.411,1.592C24.58,20.674,27.516,21,30.757,21 c3.196,0,6.095-0.317,8.645-0.842l-4.315-1.613c-0.341-0.128-0.575-0.382-0.606-0.654l-0.121-1.045 C36.547,16.132,37.55,14.835,37.784,13.359"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoins);
export default __webpack_public_path__ + "static/media/icon_coins.1dd1ec3de6cf2c2be2dcf8be72cb01b7.svg";
export { ForwardRef as ReactComponent };